import { Box, type SxProps, type Theme } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  MultiSectionDigitalClock,
  type MultiSectionDigitalClockProps,
} from "@mui/x-date-pickers/MultiSectionDigitalClock";

interface TimePickerProps extends MultiSectionDigitalClockProps<Date> {
  /**
   * Useful when TimePicker is nested within a parent that also captures touch events
   * If `true`, `event.stopPropagation()` will be called immediately on touch capture
   * which will prevent the parent from stealing the picker's touch events
   */
  preventParentTouchStart?: boolean;
  containerSx?: SxProps<Theme>;
}

export function TimePicker(props: TimePickerProps) {
  const { preventParentTouchStart, containerSx, ...clockProps } = props;

  return (
    <Box
      sx={containerSx}
      onTouchStartCapture={
        preventParentTouchStart
          ? (event) => {
              event.stopPropagation();
            }
          : undefined
      }
    >
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <MultiSectionDigitalClock
          sx={{
            justifyContent: "center",
            "& .MuiList-root": {
              scrollbarWidth: "none",
            },
          }}
          {...clockProps}
        />
      </LocalizationProvider>
    </Box>
  );
}
